export default __webpack_public_path__ + "ca47c1fceb740d762412cadca9ef69cc.png";